import React, { useContext } from 'react'
import styles from './ImagePopup.module.css';

const ImagePopup = (props) => {
	const image_src = props.image_src;
	const image_alt = props.image_alt;
	const title_message = props.title_message;
	return (
		<Popup isHidden={false} image_src={image_src} image_alt={image_alt} title_message={title_message}/>
	)
}

export class Popup extends React.Component {
	constructor(props) {
		super(props);
		this.state = { isHidden: props.isHidden, image_src: props.image_src, image_alt: props.image_alt, title_message: props.title_message };

		// This binding is necessary to make `this` work in the callback
		this.handleClick = this.handleClick.bind(this);
	}

	handleClick() {
		this.setState(prevState => ({
			isHidden: !prevState.isHidden
		}));
	}

	render() {
		return (
			<div  
				tabIndex="0"
				role="button"
				aria-pressed="false"
				data_tealium_category="page_banner"
				data_tealium_action="click"
				data_tealium_type="action"
				data_tealium_value= {`${this.state.title_message}`}
				title={this.state.title_message} className={styles.pageMask} 
				onClick={this.handleClick} 
				style={{visibility: `${this.state.isHidden ? 'hidden' : 'visible'}`}}>
				<img src={this.state.image_src} alt={this.state.image_alt} className={styles.contentBox}></img>
			</div >
		);
	}
}

export default ImagePopup;


